import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { getZendeskScriptUrl } from "../../../config/config";
import { getVendorConfig, type Brand } from "../vendorConfig";

const initZendeskAtom = atom<Brand | null>(null);

export const useInitZendesk = () => {
  const [scriptLoaded, setScriptLoaded] = useAtom(initZendeskAtom);
  const vendorConfig = getVendorConfig();

  useEffect(() => {
    if (
      vendorConfig?.supportWidget &&
      scriptLoaded !== vendorConfig.brandCode
    ) {
      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src = `${getZendeskScriptUrl()}${
        vendorConfig.supportWidget.zendeskKey
      }`;
      script.type = "text/javascript";
      script.async = true;

      script.onload = () => setScriptLoaded(vendorConfig.brandCode);
      script.onerror = () => console.error("Zendesk failed to load");

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
    return;
  }, [scriptLoaded, setScriptLoaded, vendorConfig]);
};
